__turbopack_context__.v({
  "className": "jetbrains_mono_b8f10d8e-module__j7QSha__className",
  "variable": "jetbrains_mono_b8f10d8e-module__j7QSha__variable",
});
